import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { DataTableColumn } from '../models/data-table-column';
import { DataTableDefinition } from '../models/data-table-definition';
import { FormatterService, FieldConventionService, dateFormatter, LookupPipe, LookupService } from 'src/app/stp/stp-app/forms';

@Injectable()
export class DataTableConventionService<T> {

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private formatterService: FormatterService,
    private fieldConventionService: FieldConventionService,
    private lookupService: LookupService
  ) {}

  public applyConventions(configuration: DataTableDefinition<T>): DataTableDefinition<T> {
    this.columnDefaults(configuration.columns);

    return configuration;
  }

  private columnDefaults(columns: DataTableColumn<T>[]) {
    columns.forEach(column => {
      if (!column.header) {
        column.header = this.fieldConventionService.getDefaultLabel(column.name as string);
      }

      if (!column.formatter && !column.valueProvider && this.fieldConventionService.isLookupField(column.name as string)) {
        const lookupName = this.lookupService.getDefaultLookupName(column.name as string);
        column.formatter = this.formatterService.lookupFormatter(lookupName);
      }

      if (!column.formatter) {
        column.formatter = this.passthroughFormatter;
      }

      if (!column.valueProvider) {
        column.valueProvider = (dataItem: T) => {
          const dataItemValue: any = dataItem[column.name];

          if (column.formatter === this.passthroughFormatter && this.fieldConventionService.isDate(dataItemValue)) {
            column.formatter = (value: any) => dateFormatter(value, this.locale);
          }

          return column.formatter(dataItemValue);
        };
      }
    });
  }

  private passthroughFormatter = (dataItemValue) => {
    return dataItemValue;
  }
}
